// src/hooks/useUserTier.js
import { useState, useEffect } from 'react';

/**
 * Hook to get current user's subscription tier
 * Returns: 'free', 'pro', or 'elite'
 *
 * Reads from localStorage keys:
 * - userTier (production)
 * - dev_subscription_tier (development override)
 */
const useUserTier = () => {
  const [tier, setTier] = useState('pro'); // Default to 'pro' for development

  useEffect(() => {
    // Check for dev override first (used in dashboard testing)
    const devTier = localStorage.getItem('dev_subscription_tier');
    if (devTier) {
      setTier(devTier);
      return;
    }

    // Check production tier
    const userTier = localStorage.getItem('userTier');
    if (userTier) {
      setTier(userTier);
      return;
    }

    // Default to 'pro' if no tier is set (during development)
    setTier('pro');
  }, []);

  // Listen for tier changes (e.g., when user upgrades or admin switches)
  useEffect(() => {
    const handleStorageChange = (e) => {
      // Handle both native storage events (with e.key) and manual dispatches (without e.key)
      if (!e.key || e.key === 'userTier' || e.key === 'dev_subscription_tier') {
        const devTier = localStorage.getItem('dev_subscription_tier');
        const userTier = localStorage.getItem('userTier');
        setTier(devTier || userTier || 'pro');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return tier;
};

export default useUserTier;
